import BottomModal from "components/common/Modal/BottomModal";
import Button from "components/common/buttons/buttons";
import { useTranslation } from "react-i18next";
import { TYPO } from "styles/Typo";
import useModalClickOutside from "utils/useModalClickOutside";

function RiskRankingModal({ setModalOpen, isModalOpen }: any) {
  const { t } = useTranslation("detail");
  const modalRef = useModalClickOutside(setModalOpen);

  return (
    <BottomModal
      isOpen={isModalOpen}
      modalRef={modalRef}
      containerClass="gap-[17px]"
    >
      <h1 className={`${TYPO.TYPO4_B} text-gray80`}>
        {t("whatIsRiskRanking")}
      </h1>

      <div className="w-full  flex-col justify-start items-start gap-[5px] inline-flex">
        <div className="w-full whitespace-pre-line break-keep">
          <span className={`${TYPO.TYPO5_MD} text-gray60 !text-[17px]`}>
            {t("riskRankingDescription1")}
          </span>
          <span className={`${TYPO.TYPO5_SB} text-gray80 !text-[17px]`}>
            {t("riskRankingDescription2")}
          </span>
          <span className={`${TYPO.TYPO5_MD} text-gray60 !text-[17px]`}>
            {t("riskRankingDescription3")}
          </span>
        </div>
      </div>
      <div className="w-full px-6 py-[18px] bg-gray-50 rounded-2xl flex-col justify-start items-start gap-[5px] flex">
        <h3 className={`${TYPO.TYPO7_SB} !text-[14px] text-gray80`}>
          {t("rankBasedLevel")}
        </h3>
        <span
          className={`text-zinc-500 text-sm font-normal leading-snug whitespace-pre-line`}
        >
          {t("levels")}
        </span>
      </div>

      <div className={`${TYPO.TYPO8_MD} text-gray40`}>
        {t("bottomDescription")}
      </div>

      <Button
        type={"primary"}
        size={"lg"}
        text={t("confirm")}
        width="w-full  mt-[3px]"
        clickHandler={() => setModalOpen(false)}
      />
    </BottomModal>
  );
}
export default RiskRankingModal;
